// extracted by mini-css-extract-plugin
module.exports = {"handle":"Handle--handle--1EPRd"};